import {Container, Menu} from "semantic-ui-react";
import {Syllabary} from "../WordFetcher";
import * as React from "react";
import Dropdown from "semantic-ui-react/dist/commonjs/modules/Dropdown";
import {ResetModal} from "./ResetModal";
import {AboutModal} from "./AboutModal";
import {VolumeToggle} from "./VolumeToggle";
import {MissingLanguageModal} from "./MissingLanguageModal";

interface IProps {
    changeSyllabary(syllabary: Syllabary): void;

    currentSyllabary: Syllabary;

    resetStateFromStorage(syllabary: Syllabary): void;

    togglePlaySound(): void;
    playSound: boolean;
    showAbout: boolean;
    showMissingLanguageModal: boolean;
    setShowMissingLanguageModal(newValue: boolean): void
}

interface IState {
    showRemoveModal: boolean;
    removeSyllabary?: Syllabary;
}

export class AppMenu extends React.Component<IProps, IState> {
    constructor(props: IProps) {
        super(props);
        this.toggleRemoveModal = this.toggleRemoveModal.bind(this);
        this.state = {
            showRemoveModal: false,
        }
    };

    private toggleRemoveModal(syllabary: Syllabary) {
        this.setState({
            removeSyllabary: syllabary,
            showRemoveModal: !this.state.showRemoveModal,
        })
    }

    public render() {
        return (
            <Menu>
                <Container>
                    <Menu.Item header>
                        KanaReader
                    </Menu.Item>
                    <Menu.Item
                        onClick={() => {
                            this.props.changeSyllabary(Syllabary.hiragana)
                        }}
                        active={this.props.currentSyllabary == Syllabary.hiragana}
                    >
                        か
                    </Menu.Item>
                    <Menu.Item
                        onClick={() => {
                            this.props.changeSyllabary(Syllabary.katakana)
                        }}
                        active={this.props.currentSyllabary == Syllabary.katakana}
                    >
                        カ
                    </Menu.Item>
                    <Menu.Item
                        onClick={this.props.togglePlaySound}>
                        <VolumeToggle playSound={this.props.playSound}></VolumeToggle>
                    </Menu.Item>
                    <Menu.Item>
                        <Dropdown text="More">
                            <Dropdown.Menu>
                                <Dropdown.Item>
                                    <Dropdown text="Clear Progress">
                                        <Dropdown.Menu>
                                            <Dropdown.Item
                                                onClick={() => this.toggleRemoveModal(Syllabary.hiragana)}>Hiragana</Dropdown.Item>
                                            <Dropdown.Item
                                                onClick={() => this.toggleRemoveModal(Syllabary.katakana)}>Katakana</Dropdown.Item>
                                        </Dropdown.Menu>
                                    </Dropdown>
                                </Dropdown.Item>
                                <AboutModal open={this.props.showAbout}/>
                                <MissingLanguageModal open={this.props.showMissingLanguageModal} setShowMissingLanguageModal={this.props.setShowMissingLanguageModal}/>
                            </Dropdown.Menu>
                        </Dropdown>
                    </Menu.Item>
                </Container>
                <ResetModal
                    syllabary={this.state.removeSyllabary!}
                    open={this.state.showRemoveModal}
                    toggleFn={this.toggleRemoveModal}
                    resetStateFromStorage={() => {
                        this.props.resetStateFromStorage(this.state.removeSyllabary!)
                    }}
                />
            </Menu>
        )
    }
}


// WEBPACK FOOTER //
// ./src/components/AppMenu.tsx